var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { class: _vm.getColorStyle }, [
                _vm._v(" " + _vm._s(_vm.textTitle) + " "),
              ]),
              _c("v-img", {
                staticStyle: {
                  display: "block",
                  margin: "0 auto",
                  width: "25%",
                  height: "25%",
                },
                attrs: { src: _vm.getIcon },
              }),
              _c(
                "v-card-text",
                {
                  staticClass: "pt-2 body-3 headline text-center align-center",
                },
                [
                  _c("span", { class: _vm.getColorText }, [
                    _vm._v(_vm._s(_vm.statusDevice)),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticStyle: { "margin-left": "4%" } },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pt-3 body-1 font-weight-medium" },
                    [
                      _vm._v(' Se presiónó el botón de pánico "'),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.device.name)),
                      ]),
                      _vm._v('" de la estación "'),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.device.station)),
                      ]),
                      _vm._v('". '),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-around",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "pt-3 body-1 font-weight-medium" },
                        [
                          _vm._v("Cedula: "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("1076904331"),
                          ]),
                          _vm._v("."),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "pt-3 body-1 font-weight-medium" },
                        [
                          _vm._v("Email: "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("example@hotmail.com"),
                          ]),
                          _vm._v("."),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-left": "4%" } },
                  [
                    _c(
                      "v-card-text",
                      { staticClass: "pt-3 body-1 font-weight-medium" },
                      [
                        _vm._v("Fecha: "),
                        _c("span", { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDateShort")(_vm.device.lastUpdate)
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticStyle: { "margin-left": "4%" } },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pt-3 body-1 font-weight-medium" },
                    [
                      _vm._v("Nombre de Usuario: "),
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.device.nameUser)),
                      ]),
                      _vm._v("."),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c("v-spacer"),
              _c(
                "l-map",
                {
                  staticClass: "style_map",
                  attrs: { zoom: this.zoom, center: _vm.coorde },
                },
                [
                  _c("l-tile-layer", {
                    attrs: { url: _vm.url, attribution: _vm.attribution },
                  }),
                  _c(
                    "l-marker",
                    { attrs: { "lat-lng": _vm.coorde } },
                    [
                      _c("l-popup", [
                        _c("div", [
                          _vm._v(" " + _vm._s(_vm.device.name) + " "),
                          _c("div", [
                            _vm.device.name == "post"
                              ? _c("span", [_vm._v("POSTPAGO")])
                              : _vm._e(),
                            _vm.device.name == "pre"
                              ? _c("span", [_vm._v("PREPAGO")])
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      class: _vm.getColorStyle,
                      staticStyle: { "border-bottom": "1px" },
                      attrs: {
                        depressed: "",
                        dark: "",
                        to: {
                          name: "DeviceID_loRaWan",
                          params: { id: _vm.device.id },
                        },
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.textButton) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }